exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#_1NsI7esKBxIxEcDNvI-E6V{position:fixed;top:0;left:0;z-index:3;border:10px solid transparent;width:100%;height:100%;-webkit-transition:opacity 10s;transition:opacity 10s}", ""]);

// exports
exports.locals = {
	"root": "_1NsI7esKBxIxEcDNvI-E6V"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?module&-autoprefixer!./~/postcss-loader!./src/components/App/Connected/index.css
// module id = 474
// module chunks = 1